import { decode, encode } from 'base-64'
import Cookies from 'js-cookie'

function getAuthCookie(): string | null {
  const cookie = Cookies.get('professional_auth_token')
  if (!cookie) {
    return null
  }
  try {
    return JSON.parse(decode(cookie))
  } catch {
    return null
  }
}

function setAuthCookie(value: string): void {
  Cookies.set('professional_auth_token', encode(JSON.stringify(value)), {
    // Keyed off the actual scheme rather than hardcoded: a Secure cookie is
    // silently dropped over plain http, which would break local dev in browsers
    // that don't treat localhost as a secure context.
    secure: window.location.protocol === 'https:',
    sameSite: 'lax',
  })
}

function removeAuthCookie(): void {
  Cookies.remove('professional_auth_token')
}

type getAuthCookie = () => string | null
type setAuthCookie = (value: string) => void
type removeAuthCookie = () => void

export { getAuthCookie, setAuthCookie, removeAuthCookie }
